import { useGameStore } from '@store/gameStore'
import './LandingPage.css'

// Fake Reviews Data
const FAKE_REVIEWS = [
    {
        stars: 5,
        text: "Hab noch nie einen Cent ausgegeben!",
        author: "TotallyRealPerson_42"
    },
    {
        stars: 5,
        text: "Endlich ein faires Free2Play Spiel!",
        author: "DefinitelyNotABot"
    },
    {
        stars: 5,
        text: "Meine Kinder lieben es! Keine Käufe nötig.",
        author: "HappyMom2023"
    },
    {
        stars: 5,
        text: "Ich spiele seit 2 Jahren gratis auf Rang #1!",
        author: "xX_ProGamer_Xx"
    },
    {
        stars: 5,
        text: "Beste Entscheidung meines Lebens!",
        author: "NotPaidToSayThis"
    },
]

// Fake Stats
const FAKE_STATS = {
    downloads: "50.000.000+",
    rating: "4.9",
    awards: ["2024", "2025", "2026"],
    countries: 195,
}

export function LandingPage() {
    const startGame = useGameStore(state => state.startGame)

    const handleStart = () => {
        startGame()
    }

    return (
        <div className="landing">
            {/* Hero Section */}
            <section className="landing__hero">
                <div className="landing__logo">
                    <img src="./logo.png" alt="Pay2Lose" className="landing__logo-img" />
                </div>

                <h2 className="landing__tagline">
                    DAS #1 STRATEGIE-SPIEL
                </h2>


            </section>


            {/* CTA Button */}
            <section className="landing__cta">
                <button
                    className="btn btn--gold btn--lg btn--full landing__start-btn"
                    onClick={handleStart}
                >
                    JETZT KOSTENLOS STARTEN!
                </button>
                <div className="landing__rating">
                    <span className="landing__stars">⭐⭐⭐⭐⭐</span>
                    <span className="landing__rating-text">{FAKE_STATS.rating} - "BESTES SPIEL ALLER ZEITEN!"</span>
                </div>
            </section>


            {/* Promises Section */}
            <section className="landing__promises">
                <div className="landing__promise">
                    <span className="landing__promise-icon">💰</span>
                    <span className="landing__promise-text">100% GRATIS SPIELEN!</span>
                </div>
                <div className="landing__promise">
                    <span className="landing__promise-icon">🎁</span>
                    <span className="landing__promise-text">KEINE WERBUNG!</span>
                </div>
                <div className="landing__promise">
                    <span className="landing__promise-icon">⚡</span>
                    <span className="landing__promise-text">KEINE WARTEZEITEN!</span>
                </div>
            </section>

            {/* Reviews Section */}
            <section className="landing__reviews">
                <h2 className="landing__section-title">💬 WAS SPIELER SAGEN:</h2>

                <div className="landing__reviews-list">
                    {FAKE_REVIEWS.slice(0, 4).map((review, index) => (
                        <div key={index} className="fake-review">
                            <div className="fake-review__stars">
                                {'⭐'.repeat(review.stars)}
                            </div>
                            <p className="fake-review__text">"{review.text}"</p>
                            <span className="fake-review__author">- {review.author}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* Stats Section */}
            <section className="landing__stats">
                <div className="landing__stat">
                    <span className="landing__stat-icon">📊</span>
                    <span className="landing__stat-text">ÜBER {FAKE_STATS.downloads} DOWNLOADS</span>
                </div>
                <div className="landing__stat landing__stat--awards">
                    <span className="landing__stat-icon">🏆</span>
                    <span className="landing__stat-text">GAME OF THE YEAR</span>
                    <div className="landing__awards">
                        {FAKE_STATS.awards.map((year) => (
                            <span key={year} className="landing__award-badge">{year}</span>
                        ))}
                    </div>
                </div>
                <div className="landing__stat">
                    <span className="landing__stat-icon">🌍</span>
                    <span className="landing__stat-text">IN {FAKE_STATS.countries} LÄNDERN VERFÜGBAR</span>
                </div>
            </section>

            {/* Warning (satirical) */}
            <section className="landing__warning">
                <p>⚠️ WARNUNG: Kann zu extremem Spielspaß führen!</p>
            </section>

            {/* Second CTA */}
            <section className="landing__cta landing__cta--bottom">
                <button
                    className="btn btn--gold btn--lg btn--full landing__start-btn"
                    onClick={handleStart}
                >
                    🎮 GRATIS SPIELEN 🎮
                </button>
                <p className="landing__fine-print">
                    Keine Kreditkarte erforderlich! Keine versteckten Kosten!*
                </p>
                <p className="landing__fine-print landing__fine-print--tiny">
                    *Aussage kann von der Realität abweichen
                </p>
            </section>
        </div >
    )
}
